import React from 'react';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
  onLogout: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, onLogout }) => {
  return (
    <>
      <style>
        {`
          .layout-container {
            display: flex;
            min-height: 100vh;
          }
          
          .layout-main {
            flex: 1;
            margin-left: 56px;
            display: flex;
            flex-direction: column;
          }
          
          .layout-content {
            flex: 1;
            position: relative;
            padding-top: 50px;
            height: 100vh;
            overflow-y: auto;
          }
        `}
      </style>
      
      <div className="layout-container">
        <Sidebar onLogout={onLogout} />
        
        <main className="layout-main">
          <div className="layout-content">
            {children}
          </div>
        </main>
      </div>
    </>
  );
};

export default Layout; 